import { Table } from "../../../features/Table";
import { useTranslation } from "react-i18next";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

import {
  type A5Portfolio,
  porfolios_columns,
  columnVisibilityInit,
} from "./columns";
import { type FilterA5PortfoliosSchema, FilterA5Portfolios } from "./filter";

export const A5PortfoliosTable = () => {
  const { t } = useTranslation();

  return (
    <Table<A5Portfolio, FilterA5PortfoliosSchema>
      label={t(`${Tables.A5_PORTFOLIOS}.title`, {
        ns: "tables",
        defaultValue: "Portfolios",
      })}
      client={Clients.A5}
      table_name={`${Tables.A5_PORTFOLIOS}`}
      columns={porfolios_columns}
      columnVisibilityInit={columnVisibilityInit}
      filter={<FilterA5Portfolios />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.A5}/${Tables.A5_PORTFOLIOS}/new`,
        },
      ]}
    />
  );
};
